import $ from "jquery";
import "../../assets/libs/bootstrap-5.0.2-dist/js/bootstrap.bundle.min.js";
import * as AOS from "../../assets/libs/aos";
import Footer from "@/components/footer/Footer";
import Header from "@/components/header/header";
import Swal from "sweetalert2";
import Toolbar from "@/components/toolbar/toolbar";
import VueSlickCarousel from 'vue-slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default {
    name: "Home",
    data() {
        return {
            mediaItems: [
                { type: 'image', src: 'path/to/image1.jpg', alt: 'Image 1' },
                { type: 'video', src: 'path/to/video1.mp4' },
                // Add more media items as needed
            ],
            bannerImageTh: { m: require("@/assets/img/banner/banner2026m_th.webp"), pc: require("@/assets/img/banner/banner2026_th.webp") },
            bannerImageEn: { m: require("@/assets/img/banner/banner2026m_en.webp"), pc: require("@/assets/img/banner/banner2026_en.webp") },
            // imageSource: require("@/assets/img/build-color/building-img-color1.png"),
            list_build: [],
            // list_build: [
            //   {
            //     id: 1,
            //     name: this.$t("home.findYourGlass.lowBuilding"),
            //     img: require("@/assets/img/Home/i-build-sm.png"),
            //     width_icon: "40",
            //     type_glass: [],
            //     type_color: [],
            //     range_protection: [
            //       {
            //         id: 1,
            //         name: this.$t("home.findYourGlass.properLight"),
            //         value: 3,
            //       },
            //       {
            //         id: 2,
            //         name: this.$t("home.findYourGlass.properHeatProtection"),
            //         value: 4,
            //       },
            //     ],
            //     protection: [
            //       { id: 1, name: this.$t("home.findYourGlass.safety"), value: true },
            //       {
            //         id: 2,
            //         name: this.$t("home.findYourGlass.UVProtection"),
            //         value: false,
            //       },
            //       {
            //         id: 3,
            //         name: this.$t("home.findYourGlass.noiseReducer"),
            //         value: true,
            //       },
            //     ],
            //   },
            //   {
            //     id: 2,
            //     name: this.$t("home.findYourGlass.highBuilding"),
            //     img: require("@/assets/img/Home/i-build-lg.png"),
            //     width_icon: "30",
            //     type_glass: [],
            //     type_color: [],
            //     range_protection: [
            //       {
            //         id: 1,
            //         name: this.$t("home.findYourGlass.properLight"),
            //         value: 3,
            //       },
            //       {
            //         id: 2,
            //         name: this.$t("home.findYourGlass.properHeatProtection"),
            //         value: 4,
            //       },
            //     ],
            //     protection: [
            //       { id: 1, name: this.$t("home.findYourGlass.safety"), value: true },
            //       {
            //         id: 2,
            //         name: this.$t("home.findYourGlass.UVProtection"),
            //         value: false,
            //       },
            //       {
            //         id: 3,
            //         name: this.$t("home.findYourGlass.noiseReducer"),
            //         value: true,
            //       },
            //     ],
            //   },
            // ],
            // type_glass: [
            //   {
            //     id: 1,
            //     name: "อาคารขนาดเล็ก",
            //     list_glass: [
            //       { id: 1, name: this.$t("home.findYourGlass.sheet") },
            //       { id: 2, name: this.$t("home.findYourGlass.laminated") },
            //       { id: 3, name: this.$t("home.findYourGlass.insulated") },
            //       { id: 4, name: this.$t("home.findYourGlass.laminatedInsulated") },
            //     ],
            //   },
            //   {
            //     id: 2,
            //     name: "อาคารขนาดสูง",
            //     list_glass: [
            //       { id: 2, name: this.$t("home.findYourGlass.laminated") },
            //       { id: 3, name: this.$t("home.findYourGlass.insulated") },
            //       { id: 4, name: this.$t("home.findYourGlass.laminatedInsulated") },
            //     ],
            //   },
            // ],
            // show_glass: [
            //   { id: 1, name: this.$t("home.findYourGlass.sheet") },
            //   { id: 2, name: this.$t("home.findYourGlass.laminated") },
            //   { id: 3, name: this.$t("home.findYourGlass.insulated") },
            //   { id: 4, name: this.$t("home.findYourGlass.laminatedInsulated") },
            // ],
            // show_building: [
            //   {
            //     name: "อาคารแนวราบขนาดเล็ก/อาคารสูง/ขนาดใหญ่/ขนาดใหญ่พิเศษ",
            //     img: require("@/assets/img/findyourglass/build/build_1.png"),
            //   },
            //   {
            //     name: "อาคารแนวราบขนาดเล็ก",
            //     img: require("@/assets/img/findyourglass/build/build_3.png"),
            //   },
            //   {
            //     name: "อาคารสูง/ขนาดใหญ่/ขนาดใหญ่พิเศษ",
            //     img: require("@/assets/img/findyourglass/build/build_2.png"),
            //   },
            // ],
            // type_color: [
            //   { id: 1, name: this.$t("home.findYourGlass.clear"), color: "white-normal" },
            //   { id: 2, name: this.$t("home.findYourGlass.green"), color: "green-lime" },
            //   { id: 3, name: this.$t("home.findYourGlass.darkGrey"), color: "orange-normal" },
            //   { id: 4, name: this.$t("home.findYourGlass.skyBlue"), color: "sky-normal" },
            //   { id: 5, name: this.$t("home.findYourGlass.grey"), color: "gray-dark" },
            //   { id: 6, name: this.$t("home.findYourGlass.bronzeGold"), color: "yellow-light" },
            //   { id: 7, name: this.$t("home.findYourGlass.other"), color: "black-normal" },
            // ],
            // range_protection: [
            //   {
            //     id: 1,
            //     name: this.$t("home.findYourGlass.properLight"),
            //     img: require("@/assets/img/Home/icon/icon-type-sun.png"),
            //     remark: "Proper Light > 30%",
            //   },
            //   {
            //     id: 2,
            //     name: this.$t("home.findYourGlass.properHeatProtection"),
            //     img: require("@/assets/img/Home/icon/icon-type-hot.png"),
            //     remark: "Proper Heat Protection > 45%",
            //   },
            // ],
            // protection: [
            //   {
            //     id: 1,
            //     name: this.$t("home.findYourGlass.safety"),
            //     img: require("@/assets/img/Home/icon/icon-type-protection.png"),
            //   },
            //   {
            //     id: 2,
            //     name: this.$t("home.findYourGlass.UVProtection"),
            //     img: require("@/assets/img/Home/icon/icon-type-uv.png"),
            //   },
            //   {
            //     id: 3,
            //     name: this.$t("home.findYourGlass.noiseReducer"),
            //     img: require("@/assets/img/Home/icon/icon-type-sound.png"),
            //   },
            // ],
            // list_protection: [
            //   {
            //     id: 1,
            //     name: this.$t("home.findYourGlass.safety"),
            //     img: require("@/assets/img/findyourglass/i_protection/i_1.png"),
            //   },
            //   {
            //     id: 2,
            //     name: this.$t("home.findYourGlass.UVProtection"),
            //     img: require("@/assets/img/findyourglass/i_protection/i_2.png"),
            //   },
            //   {
            //     id: 3,
            //     name: this.$t("home.findYourGlass.noiseReducer"),
            //     img: require("@/assets/img/findyourglass/i_protection/i_3.png"),
            //   },
            // ],
            // value_of_range_glass: [
            //   { id: 1, name_display: "<-20", name_show: "<-20%" },
            //   { id: 2, name_display: "21-30", name_show: "21-30%" },
            //   { id: 3, name_display: "31-40", name_show: "31-40%" },
            //   { id: 4, name_display: "41-50", name_show: "41-50%" },
            //   { id: 5, name_display: "51-60", name_show: "51-60%" },
            //   { id: 6, name_display: "61->", name_show: "61%->" },
            // ],
            // list_result_glass: [],
            result: [],
            toggleEnable: false,
            // lists_color: [
            //   {
            //     id: 1,
            //     name_color: "gray-dark",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 2,
            //     name_color: "gray-normal",
            //     img: require("@/assets/img/Home/example_glass_02.png"),
            //   },
            //   {
            //     id: 3,
            //     name_color: "gray-light",
            //     img: require("@/assets/img/Home/example_glass_03.png"),
            //   },
            //   {
            //     id: 4,
            //     name_color: "white-dark",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 5,
            //     name_color: "white-normal",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 6,
            //     name_color: "sky-light",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 7,
            //     name_color: "green-lime",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 8,
            //     name_color: "sky-normal",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 9,
            //     name_color: "orange-light",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 10,
            //     name_color: "green-light",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 11,
            //     name_color: "yellow-light",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 12,
            //     name_color: "orange-normal",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 13,
            //     name_color: "purple-normal",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 14,
            //     name_color: "black-normal",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            //   {
            //     id: 15,
            //     name_color: "snow",
            //     img: require("@/assets/img/Home/example_glass_01.png"),
            //   },
            // ],
            // current_color: {
            //   id: 1,
            //   name_color: "gray-dark",
            //   img: require("@/assets/img/Home/example_glass_01.png"),
            // },
            loadVideo: false,
            banner_desktop: "",
            banner_full_screen: "",
            banner_mobile: "",
            group_product: [],
            product_content: [],
            product: [],
            desktop_muted: true,
            mobile_muted: true,
            advance: false,
            baseFront: this.$baseFront,
            showModal: false,

            index_compare: [1, 2, 3],
            imageSource: require('@/assets/img/build-color/building-img-color1.png'),
            type_building: [{
                    name: this.$t("compare.allBuilding"),
                    img: require("@/assets/img/findyourglass/build/build_1.png"),
                },
                {
                    name: this.$t("compare.lowBuilding"),
                    img: require("@/assets/img/findyourglass/build/build_3.png"),
                },
                {
                    name: this.$t("compare.highBuilding"),
                    img: require("@/assets/img/findyourglass/build/build_2.png"),
                },
            ],
            list_protection: [
                { id: 1, name: "ปลอดภัย", img: require('@/assets/img/compare/i_protection/i_1.png') },
                { id: 2, name: "UV", img: require('@/assets/img/compare/i_protection/i_2.png') },
                { id: 3, name: "เสียง", img: require('@/assets/img/compare/i_protection/i_3.png') },
            ],
            lists_color1: [
                { id: 1, name_color: "gray-dark", img: require('@/assets/img/Home/example_glass_01.png'), type: 1, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: true }, { id: 3, name: "เสียง", value: true }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 2, name_color: "gray-normal", img: require('@/assets/img/Home/example_glass_02.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "22", vlt: "10", vlr_out: "13", vlr_in: "15", det: "85", er: "43", ea: "48", sc: "0.24", shgc: "21", lsg: "0.21", u_value: "5.59", rhg: "6.38", price: "3" },
                { id: 3, name_color: "gray-light", img: require('@/assets/img/Home/example_glass_03.png'), type: 3, type_protection: [{ id: 1, name: "ปลอดภัย", value: false }, { id: 2, name: "UV", value: true }, { id: 3, name: "เสียง", value: true }], thickness: "5", vlt: "80", vlr_out: "83", vlr_in: "85", det: "55", er: "43", ea: "18", sc: "0.98", shgc: "76", lsg: "0.55", u_value: "3.59", rhg: "7.12", price: "1" },
                { id: 4, name_color: "white-dark", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 5, name_color: "white-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 6, name_color: "sky-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 7, name_color: "green-lime", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 8, name_color: "sky-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 9, name_color: "orange-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 10, name_color: "green-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 11, name_color: "yellow-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 12, name_color: "orange-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 13, name_color: "purple-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 14, name_color: "black-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 15, name_color: "snow", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
            ],
            lists_color2: [
                { id: 1, name_color: "gray-dark", img: require('@/assets/img/Home/example_glass_01.png'), type: 1, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: true }, { id: 3, name: "เสียง", value: true }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 2, name_color: "gray-normal", img: require('@/assets/img/Home/example_glass_02.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "22", vlt: "10", vlr_out: "13", vlr_in: "15", det: "85", er: "43", ea: "48", sc: "0.24", shgc: "21", lsg: "0.21", u_value: "5.59", rhg: "6.38", price: "3" },
                { id: 3, name_color: "gray-light", img: require('@/assets/img/Home/example_glass_03.png'), type: 3, type_protection: [{ id: 1, name: "ปลอดภัย", value: false }, { id: 2, name: "UV", value: true }, { id: 3, name: "เสียง", value: true }], thickness: "5", vlt: "80", vlr_out: "83", vlr_in: "85", det: "55", er: "43", ea: "18", sc: "0.98", shgc: "76", lsg: "0.55", u_value: "3.59", rhg: "7.12", price: "1" },
                { id: 4, name_color: "white-dark", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 5, name_color: "white-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 6, name_color: "sky-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 7, name_color: "green-lime", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 8, name_color: "sky-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 9, name_color: "orange-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 10, name_color: "green-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 11, name_color: "yellow-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 12, name_color: "orange-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 13, name_color: "purple-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 14, name_color: "black-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 15, name_color: "snow", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
            ],
            lists_color3: [
                { id: 1, name_color: "gray-dark", img: require('@/assets/img/Home/example_glass_01.png'), type: 1, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: true }, { id: 3, name: "เสียง", value: true }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 2, name_color: "gray-normal", img: require('@/assets/img/Home/example_glass_02.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "22", vlt: "10", vlr_out: "13", vlr_in: "15", det: "85", er: "43", ea: "48", sc: "0.24", shgc: "21", lsg: "0.21", u_value: "5.59", rhg: "6.38", price: "3" },
                { id: 3, name_color: "gray-light", img: require('@/assets/img/Home/example_glass_03.png'), type: 3, type_protection: [{ id: 1, name: "ปลอดภัย", value: false }, { id: 2, name: "UV", value: true }, { id: 3, name: "เสียง", value: true }], thickness: "5", vlt: "80", vlr_out: "83", vlr_in: "85", det: "55", er: "43", ea: "18", sc: "0.98", shgc: "76", lsg: "0.55", u_value: "3.59", rhg: "7.12", price: "1" },
                { id: 4, name_color: "white-dark", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 5, name_color: "white-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 6, name_color: "sky-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 7, name_color: "green-lime", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 8, name_color: "sky-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 9, name_color: "orange-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 10, name_color: "green-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 11, name_color: "yellow-light", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 12, name_color: "orange-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 13, name_color: "purple-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 14, name_color: "black-normal", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
                { id: 15, name_color: "snow", img: require('@/assets/img/Home/example_glass_01.png'), type: 2, type_protection: [{ id: 1, name: "ปลอดภัย", value: true }, { id: 2, name: "UV", value: false }, { id: 3, name: "เสียง", value: false }], thickness: "6", vlt: "22", vlr_out: "25", vlr_in: "29", det: "18", er: "20", ea: "62", sc: "0.40", shgc: "35", lsg: "0.20", u_value: "4.25", rhg: "5.21", price: "5" },
            ],
            current_color1: {},
            current_thickness1: {},
            current_color2: {},
            current_thickness2: {},
            current_color3: {},
            current_thickness3: {},
            type_product: [],
            product: [],
            all_thickness_glass: [],
            baseFront: this.$baseFront
        };
    },
    watch: {
        async current_color() {
            $("#shade-image-preview").removeClass("aos-animate");
            setTimeout(function() {
                $("#shade-image-preview").addClass("aos-animate");
            }, 200);
        },
        async current_color1(newValue) {
            this.current_thickness1 = this.all_thickness_glass.find(i => i.glass_thickness == newValue.glass_thickness && i.ref_type_product_id == newValue.ref_type_product_id);
        },
        async current_color2(newValue) {
            this.current_thickness2 = this.all_thickness_glass.find(i => i.glass_thickness == newValue.glass_thickness && i.ref_type_product_id == newValue.ref_type_product_id);
        },
        async current_color3(newValue) {
            this.current_thickness3 = this.all_thickness_glass.find(i => i.glass_thickness == newValue.glass_thickness && i.ref_type_product_id == newValue.ref_type_product_id);
        },
    },
    methods: {
        gotoPage(url) {
            location.href = url;
        },
        gotoCompare_2() {
            this.$router.push({ path: '/compare', query: { current_1: this.current_color1.id, current_2: this.current_color2.id } })
        },
        fetchThickness(index, item) {
            if (index == 1) {
                this.current_thickness1 = item;
                this.current_color1 = this.product.filter(i => i.ref_type_product_id == this.current_thickness1.ref_type_product_id && i.glass_thickness == this.current_thickness1.glass_thickness)[0]
            }
            if (index == 2) {
                this.current_thickness2 = item;
                this.current_color2 = this.product.filter(i => i.ref_type_product_id == this.current_thickness2.ref_type_product_id && i.glass_thickness == this.current_thickness2.glass_thickness)[0]
            }
            if (index == 3) {
                this.current_thickness3 = item;
                this.current_color3 = this.product.filter(i => i.ref_type_product_id == this.current_thickness3.ref_type_product_id && i.glass_thickness == this.current_thickness3.glass_thickness)[0]
            }
        },
        clear_search() {
            this.list_build = [{
                    id: 1,
                    name: this.$t("home.findYourGlass.lowBuilding"),
                    img: require("@/assets/img/Home/i-build-sm.png"),
                    width_icon: "40",
                    type_glass: [],
                    type_color: [],
                    range_protection: [
                        { id: 1, name: this.$t("home.findYourGlass.properLight"), value: 3 },
                        { id: 2, name: this.$t("home.findYourGlass.properHeatProtection"), value: 4 },
                    ],
                    protection: [
                        { id: 1, name: this.$t("home.findYourGlass.safety"), value: true },
                        { id: 2, name: this.$t("home.findYourGlass.UVProtection"), value: false },
                        { id: 3, name: this.$t("home.findYourGlass.noiseReducer"), value: true },
                    ],
                },
                {
                    id: 2,
                    name: this.$t("home.findYourGlass.highBuilding"),
                    img: require("@/assets/img/Home/i-build-lg.png"),
                    width_icon: "30",
                    type_glass: [],
                    type_color: [],
                    range_protection: [
                        { id: 1, name: this.$t("home.findYourGlass.properLight"), value: 3 },
                        { id: 2, name: this.$t("home.findYourGlass.properHeatProtection"), value: 4 },
                    ],
                    protection: [
                        { id: 1, name: this.$t("home.findYourGlass.safety"), value: true },
                        { id: 2, name: this.$t("home.findYourGlass.UVProtection"), value: false },
                        { id: 3, name: this.$t("home.findYourGlass.noiseReducer"), value: true },
                    ],
                },
            ];
            this.advance = false;
            this.result = [];
        },
        gotoDetail(id) {
            this.$router.push(`product-content/${id}`);
        },
        async fetchProductContent() {
            await this.$axios
                .get("/api/show/type_product_content")
                .then((response) => {
                    if (response.data.code == 200) {
                        let product_content = response.data.data.map((i) => {
                            return {
                                id: i.id,
                                ref_type_product_id: i.ref_type_product_id,
                                name: i.name,
                                text_1: i.banner_text_1,
                                text_2: i.banner_text_2,
                                detail: i.feature_header ?
                                    JSON.parse(i.feature_header)[0].label : null,
                                image_vector: i.parameter_feature_list_image_vector ?
                                    JSON.parse(i.parameter_feature_list_image_vector) : null,
                                image_certificate: i.parameter_feature_list_image_certificate ?
                                    JSON.parse(i.parameter_feature_list_image_certificate) : null,
                                product: i.shade_glass ? JSON.parse(i.shade_glass) : null,
                                list_product: [],
                                current_color: {},
                            };
                        });
                        // this.product_content.fea = this.group_product.product == "" ? [] : JSON.parse(this.group_product.product)
                        this.group_product.product.forEach((i) => {
                            this.product_content.push(
                                product_content.find(
                                    (x) => x.ref_type_product_id == i.type_product
                                )
                            );
                        });
                        this.product_content.forEach((i) => {
                            if (i.product.length > 0) {
                                i.product.forEach((x) => {
                                    i.list_product.push(
                                        this.product.find((j) => j.id == x.ref_product_id)
                                    );
                                });
                                i.current_color = i.list_product[0];
                            }
                        });
                        console.log(this.product_content);
                    }
                });
        },
        async fetchHomeGroupProduct() {
            await this.$axios.get("/api/show/home_group_product").then((response) => {
                if (response.data.code == 200) {
                    this.group_product = response.data.data[0];
                    this.group_product.product =
                        this.group_product.product == "" ? [] :
                        JSON.parse(this.group_product.product);
                    console.log(this.group_product);
                }
            });
        },
        async fetchHomeBanner() {
            await this.$axios.get("/api/show/home_banner").then((response) => {
                if (response.data.code == 200) {
                    this.banner_desktop =
                        this.baseFront +
                        JSON.parse(response.data.data[0].parameter_banner)[0].image;
                    this.banner_full_screen =
                        this.baseFront +
                        JSON.parse(response.data.data[0].parameter_banner)[0].full_screen;
                    this.banner_mobile =
                        this.baseFront +
                        JSON.parse(response.data.data[0].parameter_banner)[0].image_mobile;
                }
            });
        },
        gotoCompare(item) {
            this.$router.push({ path: "/compare", query: { current_1: item.id } });
        },
        openLink(url) {
            console.log(url);
            window.open(url, "_blank");
        },
        async fetchTypeProduct() {
            await this.$axios.get("/api/show/type_product").then((response) => {
                if (response.data.code == 200) {
                    this.type_product = response.data.data;
                }
            });
        },
        async fetchProduct() {
            await this.$axios.get("/api/show/product").then((response) => {
                if (response.data.code == 200) {
                    // this.product = response.data.data;
                    // this.list_result_glass = response.data.data;
                    this.product = response.data.data
                    this.current_color1 = this.product.find(i => i.id == 7);
                    this.current_color2 = this.product.find(i => i.id == 21);
                    this.current_color3 = this.product.find(i => i.id == 99);
                    const set = new Set(this.product.map(item => JSON.stringify({ glass_thickness: item.glass_thickness, ref_type_product_id: item.ref_type_product_id })));
                    this.all_thickness_glass = Array.from(set).map(item => JSON.parse(item));
                    this.current_thickness1 = this.all_thickness_glass[0];
                    this.current_thickness2 = this.all_thickness_glass[0];
                    this.current_thickness3 = this.all_thickness_glass[0];
                }
            });
        },
        toggleButton(id) {
            if (id == 1) {
                document
                    .getElementById("find-your-glass-open-2")
                    .classList.remove("show");
            } else {
                document
                    .getElementById("find-your-glass-open-1")
                    .classList.remove("show");
            }
            this.$refs["FYGBtn" + id][0].focus();
        },
        CloseCollapse(id) {
            this.$refs["FYG" + id][0].focus();
        },
        search_glass(data) {
            this.$router.push({
                path: "/findyourglass",
                query: { findyourglass: data, advance: this.advance },
            });
            // if (data.id == 1) {
            //   this.result = [];
            //   let filter_type_glass = [];
            //   let filter_type_color = [];
            //   let filter_vlt = [];
            //   let filter_shgc = [];
            //   let protect_1 = data.protection[0].value ? 1 : 0;
            //   let protect_2 = data.protection[1].value ? 1 : 0;
            //   let protect_3 = data.protection[2].value ? 1 : 0;
            //   // ค้นหาประเภทกระจก
            //   if (data.type_glass.length > 0) {
            //     filter_type_glass = this.list_result_glass.filter((i) =>
            //       data.type_glass.includes(i.type_glass)
            //     );
            //   } else {
            //     filter_type_glass = this.list_result_glass;
            //   }
            //   // ค้นหาโทนสี
            //   if (data.type_color.length > 0) {
            //     filter_type_color = filter_type_glass.filter((i) => {
            //       if (JSON.parse(i.type_color).length == 1) {
            //         return data.type_color.includes(
            //           JSON.parse(i.type_color)[0].color
            //         );
            //       } else if (JSON.parse(i.type_color).length > 1) {
            //         return (
            //           data.type_color.includes(JSON.parse(i.type_color)[0].color) ||
            //           data.type_color.includes(JSON.parse(i.type_color)[1].color)
            //         );
            //       }
            //     });
            //   } else {
            //     filter_type_color = filter_type_glass;
            //   }
            //   if (this.advance) {
            //     filter_vlt = filter_type_color.filter((i) => {
            //       if (data.range_protection[0].value == 1) {
            //         return parseFloat(i.vlt) <= 20;
            //       } else if (data.range_protection[0].value == 2) {
            //         return parseFloat(i.vlt) >= 21 && parseFloat(i.vlt) <= 30;
            //       } else if (data.range_protection[0].value == 3) {
            //         return parseFloat(i.vlt) >= 31 && parseFloat(i.vlt) <= 40;
            //       } else if (data.range_protection[0].value == 4) {
            //         return parseFloat(i.vlt) >= 41 && parseFloat(i.vlt) <= 50;
            //       } else if (data.range_protection[0].value == 5) {
            //         return parseFloat(i.vlt) >= 51 && parseFloat(i.vlt) <= 60;
            //       } else if (data.range_protection[0].value == 6) {
            //         return parseFloat(i.vlt) >= 61;
            //       }
            //     });

            //     // ค้นหาระดับการป้องกันความร้อน
            //     filter_shgc = filter_vlt.filter((i) => {
            //       if (data.range_protection[1].value == 1) {
            //         return parseFloat(i.shgc) <= 20;
            //       } else if (data.range_protection[1].value == 2) {
            //         return parseFloat(i.shgc) >= 21 && parseFloat(i.shgc) <= 30;
            //       } else if (data.range_protection[1].value == 3) {
            //         return parseFloat(i.shgc) >= 31 && parseFloat(i.shgc) <= 40;
            //       } else if (data.range_protection[1].value == 4) {
            //         return parseFloat(i.shgc) >= 41 && parseFloat(i.shgc) <= 50;
            //       } else if (data.range_protection[1].value == 5) {
            //         return parseFloat(i.shgc) >= 51 && parseFloat(i.shgc) <= 60;
            //       } else if (data.range_protection[1].value == 6) {
            //         return parseFloat(i.shgc) >= 61;
            //       }
            //     });

            //     // ค้นหาความปลอดภัย
            //     this.result = filter_shgc.filter(
            //       (i) =>
            //         i.protect_1 == protect_1 &&
            //         i.protect_2 == protect_2 &&
            //         i.protect_3 == protect_3 &&
            //         (i.type_build == 2 || i.type_build == 1)
            //     );
            //   } else {
            //     this.result = filter_type_color;
            //   }
            //   //ค้นหาระดับแสงส่องผ่านกระจก

            //   if (this.result.length == 0) {
            //     Swal.fire({
            //       icon: "error",
            //       title: "ผลการค้นหา",
            //       text: "ไม่พบข้อมูลกระจกที่คุณค้นหา",
            //     });
            //   }
            // } else if (data.id == 2) {
            //   this.result = [];
            //   let filter_type_glass = [];
            //   let filter_type_color = [];
            //   let filter_vlt = [];
            //   let filter_shgc = [];
            //   let protect_1 = data.protection[0].value ? 1 : 0;
            //   let protect_2 = data.protection[1].value ? 1 : 0;
            //   let protect_3 = data.protection[2].value ? 1 : 0;
            //   // ค้นหาประเภทกระจก
            //   if (data.type_glass.length > 0) {
            //     filter_type_glass = this.list_result_glass.filter((i) =>
            //       data.type_glass.includes(i.type_glass)
            //     );
            //   } else {
            //     filter_type_glass = this.list_result_glass;
            //   }
            //   // ค้นหาโทนสี
            //   if (data.type_color.length > 0) {
            //     filter_type_color = filter_type_glass.filter((i) => {
            //       if (JSON.parse(i.type_color).length == 1) {
            //         return data.type_color.includes(
            //           JSON.parse(i.type_color)[0].color
            //         );
            //       } else if (JSON.parse(i.type_color).length > 1) {
            //         return (
            //           data.type_color.includes(JSON.parse(i.type_color)[0].color) ||
            //           data.type_color.includes(JSON.parse(i.type_color)[1].color)
            //         );
            //       }
            //     });
            //   } else {
            //     filter_type_color = filter_type_glass;
            //   }
            //   //ค้นหาระดับแสงส่องผ่านกระจก
            //   if (this.advance) {
            //     filter_vlt = filter_type_color.filter((i) => {
            //       if (data.range_protection[0].value == 1) {
            //         return parseFloat(i.vlt) <= 20;
            //       } else if (data.range_protection[0].value == 2) {
            //         return parseFloat(i.vlt) >= 21 && parseFloat(i.vlt) <= 30;
            //       } else if (data.range_protection[0].value == 3) {
            //         return parseFloat(i.vlt) >= 31 && parseFloat(i.vlt) <= 40;
            //       } else if (data.range_protection[0].value == 4) {
            //         return parseFloat(i.vlt) >= 41 && parseFloat(i.vlt) <= 50;
            //       } else if (data.range_protection[0].value == 5) {
            //         return parseFloat(i.vlt) >= 51 && parseFloat(i.vlt) <= 60;
            //       } else if (data.range_protection[0].value == 6) {
            //         return parseFloat(i.vlt) >= 61;
            //       }
            //     });

            //     // ค้นหาระดับการป้องกันความร้อน
            //     filter_shgc = filter_vlt.filter((i) => {
            //       if (data.range_protection[1].value == 1) {
            //         return parseFloat(i.shgc) <= 20;
            //       } else if (data.range_protection[1].value == 2) {
            //         return parseFloat(i.shgc) >= 21 && parseFloat(i.shgc) <= 30;
            //       } else if (data.range_protection[1].value == 3) {
            //         return parseFloat(i.shgc) >= 31 && parseFloat(i.shgc) <= 40;
            //       } else if (data.range_protection[1].value == 4) {
            //         return parseFloat(i.shgc) >= 41 && parseFloat(i.shgc) <= 50;
            //       } else if (data.range_protection[1].value == 5) {
            //         return parseFloat(i.shgc) >= 51 && parseFloat(i.shgc) <= 60;
            //       } else if (data.range_protection[1].value == 6) {
            //         return parseFloat(i.shgc) >= 61;
            //       }
            //     });

            //     // ค้นหาความปลอดภัย
            //     this.result = filter_shgc.filter(
            //       (i) =>
            //         i.protect_1 == protect_1 &&
            //         i.protect_2 == protect_2 &&
            //         i.protect_3 == protect_3 &&
            //         (i.type_build == 3 || i.type_build == 1)
            //     );
            //     console.log(this.result);
            //   } else {
            //     this.result = filter_type_color;
            //   }

            //   if (this.result.length == 0) {
            //     Swal.fire({
            //       icon: "error",
            //       title: "ผลการค้นหา",
            //       text: "ไม่พบข้อมูลกระจกที่คุณค้นหา",
            //     });
            //   }
            // }
        },
        search_glass_all(data) {
            if (data.id == 1) {
                this.result = [];
                // ค้นหาความปลอดภัย
                this.result = this.list_result_glass.filter(
                    (i) => i.type_build == 2 || i.type_build == 1
                );
            } else if (data.id == 2) {
                this.result = [];
                // ค้นหาความปลอดภัย
                this.result = this.list_result_glass.filter(
                    (i) => i.type_build == 3 || i.type_build == 1
                );
            }
            console.log(this.result);
        },
        toggleFullScreen() {
            // Check if the video is in full screen mode using the different fullscreen functions
            this.desktop_muted = false;
            // If the video is not in full screen mode, enter full screen mode
            if (this.video.requestFullscreen) {
                this.video.src = this.banner_full_screen;
                this.video.requestFullscreen();
            } else if (this.video.webkitRequestFullscreen) {
                this.video.src = this.banner_full_screen;
                this.video.webkitRequestFullscreen();
            } else if (this.video.mozRequestFullScreen) {
                this.video.src = this.banner_full_screen;
                this.video.mozRequestFullScreen();
            } else if (this.video.msRequestFullscreen) {
                this.video.src = this.banner_full_screen;
                this.video.msRequestFullscreen();
            }
        },
        toggleFullScreenMobile() {
            // Check if the video is in full screen mode using the different fullscreen functions
            this.mobile_muted = false;
            // If the video is not in full screen mode, enter full screen mode
            if (this.videoMobile.requestFullscreen) {
                this.videoMobile.src = this.banner_full_screen;
                this.videoMobile.requestFullscreen();
            } else if (this.videoMobile.webkitRequestFullscreen) {
                this.videoMobile.src = this.banner_full_screen;
                this.videoMobile.webkitRequestFullscreen();
            } else if (this.videoMobile.mozRequestFullScreen) {
                this.videoMobile.src = this.banner_full_screen;
                this.videoMobile.mozRequestFullScreen();
            } else if (this.videoMobile.msRequestFullscreen) {
                this.videoMobile.src = this.banner_full_screen;
                this.videoMobile.msRequestFullscreen();
            } else {
                this.videoMobile.src = this.banner_full_screen;
                window.open(this.videoMobile.src, this.banner_full_screen);
            }
            // For mobile devices, open the video in a new window
        },
    },
    async mounted() {
        this.showModal = true;
        await this.fetchHomeBanner();
        await this.fetchTypeProduct();
        await this.fetchProduct();
        await this.fetchHomeGroupProduct();
        await this.fetchProductContent();

        document.title = "AGC - Home";
        AOS.init();

        window.scrollTo(0, 0);
        await this.fetchTypeProduct();
        await this.fetchProduct();
        if (this.$route.query.current_1) {
            this.current_color1 = this.product.find(i => i.id == this.$route.query.current_1);
        }
        if (this.$route.query.current_2) {
            this.current_color2 = this.product.find(i => i.id == this.$route.query.current_2);
        }
        if (this.$route.query.compare) {
            this.current_color1 = this.product.filter(i => i.ref_type_product_id == this.$route.query.compare)[0];
            console.log(this.current_color1);
        }
        setTimeout(() => {
            this.loadVideo = true;
        }, 3000);

        // Apply resize logic directly
        if (window.innerWidth < 800) {
            $('.footer').css({ 'position': 'relative', 'top': '0px' });
        }
        // eslint-disable-next-line
        $('.m-search-BT').on('click', (evt) => {
            $('.m-search-BT + .dp').toggle()
        });
        $('img[alt="color"]').on('click', (evt) => {
            $('img[alt="color"].active').removeClass("active");
            $('#' + evt.target.id).addClass("active");
            // $('img[alt="building-img"]').attr('src',`/img/build-color/building-img-${evt.target.id}.png`); 
            this.imageSource = require(`@/assets/img/build-color/building-img-${evt.target.id}.png`)
        })


        // eslint-disable-next-line
        // $('#MapModal').modal('show');
        // $('#MapModal').modal('show');
        // this.$refs.myButton.click();
        $(".m-search-BT").on("click", (evt) => {
            $(".m-search-BT + .dp").toggle();
        });
        $('img[alt="color"]').on("click", (evt) => {
            $('img[alt="color"].active').removeClass("active");
            $("#" + evt.target.id).addClass("active");
            // $('img[alt="building-img"]').attr('src',`/img/build-color/building-img-${evt.target.id}.png`);
            this.imageSource = require(`@/assets/img/build-color/building-img-${evt.target.id}.png`);
        });
        // Get a reference to the video element
        this.video = this.$refs.myVideo;
        this.videoMobile = this.$refs.myVideoMobile;
        $("video").bind(
            "webkitfullscreenchange mozfullscreenchange fullscreenchange",
            (e) => {
                var state =
                    document.fullScreen ||
                    document.mozFullScreen ||
                    document.webkitIsFullScreen;
                // Now do something interesting
                if (!state) {
                    this.video.src = this.banner_desktop;
                    this.videoMobile.src = this.banner_mobile;
                }
            }
        );
    },
    filters: {
        list_name_protection(list) {
            let store_name_active = []
            if (list.protect_1 == 1) {
                store_name_active.push(localStorage.locale == 'th' ? 'ปลอดภัย' : 'Safety')
            }
            if (list.protect_2 == 1) {
                store_name_active.push('UV')
            }
            if (list.protect_3 == 1) {
                store_name_active.push(localStorage.locale == 'th' ? 'ปลอดภัย' : 'Sound')
            }
            return store_name_active.join("/");
        },
    },
    components: {
        Footer,
        Header,
        Toolbar,
        VueSlickCarousel,
    },
};